import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { BookOpen, ArrowRight, LogIn } from 'lucide-react';
import Button from '../components/common/Button';

const LoginPrompt: React.FC = () => {
  const location = useLocation();
  const returnUrl = `${location.pathname}${location.search}${location.hash}`;

  return (
    <div className="flex flex-col items-center justify-center bg-gradient-to-b from-purple-50 to-purple px-4 py-16 rounded-lg shadow-lg">
      <div className="text-center max-w-2xl">
        <div className="inline-flex items-center justify-center p-3 bg-purple-100 rounded-full mb-6">
          <LogIn className="h-10 w-10 text-purple-600" />
        </div>
        
        <h1 className="text-2xl font-bold text-purple-900 mb-4">
          Acesse sua conta!
        </h1>
        
        <p className="text-xl text-gray-600 mb-8 max-w-lg mx-auto">
          Crie uma conta ou faça o login para acessar os desafios da palavra do dia e pontuar no ranking!
        </p>
        
        <div className="flex flex-col sm:flex-row items-center justify-center space-y-4 sm:space-y-0 sm:space-x-4">
          <Link to="/login" state={{ from: returnUrl }}>
            <Button size="lg" rightIcon={<ArrowRight className="h-5 w-5" />}>
              Entrar
            </Button>
          </Link>
          
          <Link to="/signup" state={{ from: returnUrl }}>
            <Button size="lg" variant="outline">
              Cadastre-se
            </Button>
          </Link>
        </div>
      </div>
      
      <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-6 w-full max-w-4xl">
        <div className="bg-purple p-6 rounded-xl shadow-sm border border-purple-100">
          <div className="h-10 w-10 rounded-full bg-purple-100 flex items-center justify-center mb-4">
            <span className="text-purple-700 font-bold">1</span>
          </div>
          <h3 className="text-lg font-semibold mb-2">Daily Words</h3>
          <p className="text-gray-600">Receive a new word every day tailored to your English level.</p>
        </div>
        
        <div className="bg-purple p-6 rounded-xl shadow-sm border border-purple-100">
          <div className="h-10 w-10 rounded-full bg-purple-100 flex items-center justify-center mb-4">
            <span className="text-purple-700 font-bold">2</span>
          </div>
          <h3 className="text-lg font-semibold mb-2">Interactive Learning</h3>
          <p className="text-gray-600">Complete fun activities to reinforce your learning and vocabulary retention.</p>
        </div>
        
        <div className="bg-purple p-6 rounded-xl shadow-sm border border-purple-100">
          <div className="h-10 w-10 rounded-full bg-purple-100 flex items-center justify-center mb-4">
            <span className="text-purple-700 font-bold">3</span>
          </div>
          <h3 className="text-lg font-semibold mb-2">Track Progress</h3>
          <p className="text-gray-600">Monitor your learning journey and see how your vocabulary grows over time.</p>
        </div>
      </div>
    </div>
  );
};

export default LoginPrompt;